import { render, staticRenderFns } from "./OrganizationDescriptionModal.vue?vue&type=template&id=63db4dd0&scoped=true&"
import script from "./OrganizationDescriptionModal.vue?vue&type=script&lang=ts&"
export * from "./OrganizationDescriptionModal.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationDescriptionModal.vue?vue&type=style&index=0&id=63db4dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db4dd0",
  null
  
)

export default component.exports